// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_73-4";
export var collapsed = "_73-1";
export var headerBar = "_73-0";
export var leftHeaderContent = "_73-3";
export var subjectContainer = "_73-2";